<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Categorías</h6>
              <button class="btn btn-primary btn-sm" @click="openForm">
                Agregar <i class="fa fa-plus ms-1"></i>
              </button>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar..." @input="fetchData(null)" />
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Código</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Categoría padre</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in page.data" :key="value.id">
                    <td class="align-middle text-sm">{{ value.code || '-' }}</td>
                    <td class="align-middle text-sm">{{ value.name }}</td>
                    <td class="align-middle text-sm">{{ parentName(value.parent_id) }}</td>
                    <td class="align-middle text-center">
                      <a @click="editItem(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip" data-original-title="Editar registro">
                        <i class="fa fa-pencil-alt"></i>
                      </a>
                      <a @click="deleteItem(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="page.data && page.data.length === 0">
                    <td colspan="4" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in page.links" :key="link.label" class="page-item cursor-pointer"
                  @click="fetchData(link.url)" :disabled="!link.url || link.active"
                  :class="{ 'active': link.label === String(page.current_page) }">
                  <span v-html="link.label"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Formulario -->
    <div class="modal fade" id="ModalCategoriaForm" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">{{ isEditing ? 'Editar Categoría' : 'Agregar Categoría' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <label class="form-label">Código</label>
                <input type="text" v-model="form.code" class="form-control" placeholder="Código">
              </div>
              <div class="mb-3">
                <label class="form-label">Nombre <span class="text-danger">*</span></label>
                <input type="text" v-model="form.name" class="form-control" placeholder="Categoría" required>
              </div>
              <div class="mb-3">
                <label class="form-label">Categoría padre</label>
                <select v-model="form.parent_id" class="form-select">
                  <option value="" selected>Seleccionar</option>
                  <option v-for="p in allCategories" :key="p.id" :value="p.id">{{ p.name }}</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">Descripción</label>
                <textarea v-model="form.description" class="form-control" rows="2" placeholder="Descripción (opcional)"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cancelEdit">Cancelar</button>
            <button type="button" class="btn btn-primary" @click="submitForm"><i class="fa fa-save"></i> Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from 'bootstrap';
import Swal from 'sweetalert2';

export default {
  name: "SettingsCategorias",
  data() {
    return {
      form: { id: 0, code: '', name: '', description: '', parent_id: '' },
      searchQuery: '',
      isEditing: false,
      perPage: 10,
      page: { data: [], current_page: 1, from: 0, to: 0, total: 0, last_page: 1, prev_page_url: null, next_page_url: null, links: [] },
      allCategories: [],
      modalInstance: null,
    };
  },
  mounted() {
    this.fetchData(null);
    this.fetchAll();
  },
  methods: {
    async fetchData(pageUrl = null) {
      const page = pageUrl ? new URL(pageUrl, window.location.origin).searchParams.get('page') || 1 : 1;
      try {
        const res = await this.$store.dispatch("categories/getPaginated", { page, per_page: this.perPage, search: this.searchQuery });
        this.page = res.data;
      } catch (e) { console.error(e); }
    },
    async fetchAll() {
      try {
        const res = await this.$store.dispatch("categories/getCategories");
        this.allCategories = res.data;
      } catch (e) { console.error(e); }
    },
    parentName(parentId) {
      if (!parentId) return '';
      const p = this.allCategories.find(c => c.id === parentId);
      return p ? p.name : '';
    },
    openForm() {
      this.isEditing = false;
      this.form = { id: 0, code: '', name: '', description: '', parent_id: '' };
      this.showModal();
    },
    editItem(value) {
      this.isEditing = true;
      this.form = { id: value.id, code: value.code || '', name: value.name, description: value.description || '', parent_id: value.parent_id || '' };
      this.showModal();
    },
    showModal() {
      const el = document.getElementById('ModalCategoriaForm');
      this.modalInstance = new bootstrap.Modal(el);
      this.modalInstance.show();
    },
    hideModal() {
      if (this.modalInstance) this.modalInstance.hide();
    },
    cancelEdit() {
      this.isEditing = false;
      this.form = { id: 0, code: '', name: '', description: '', parent_id: '' };
      this.hideModal();
    },
    async submitForm() {
      try {
        const res = await this.$store.dispatch("categories/save", this.form);
        if (res && res.status >= 200 && res.status < 300) {
          this.hideModal();
          await Swal.fire({ icon: 'success', title: '¡Éxito!', text: 'Registro guardado correctamente.', confirmButtonText: 'Aceptar' });
          this.cancelEdit();
          this.fetchData(null);
          this.fetchAll();
        } else throw new Error(res.data.message || 'Error al guardar');
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'Error', text: e.message || 'Error al guardar' });
      }
    },
    async deleteItem(id) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Sí, eliminar!',
        });
        if (result.isConfirmed) {
          const res = await this.$store.dispatch("categories/delete", id);
          if (res && res.status >= 200 && res.status < 300) {
            this.fetchData(null);
            this.fetchAll();
            await Swal.fire('Eliminado!', 'Registro eliminado correctamente.', 'success');
          } else {
            throw new Error(res.data.message || 'Error al eliminar');
          }
        }
      } catch (e) {
        await Swal.fire({ icon: 'error', title: 'Error', text: e.message || 'Error al eliminar, puede tener registros asociados' });
      }
    },
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}
</style>
